import React from "react";

import { useID } from "~/lib/hooks";

export function ClickupLogo({
	style = {},
	className,
}: React.PropsWithoutRef<{ className?: string; style?: React.CSSProperties }>) {
	const linearGradient1 = useID();
	const linearGradient2 = useID();

	return (
		<svg
			style={style}
			className={className}
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2 18.4388L5.69161 15.6111C7.65195 18.1705 9.73377 19.35 12.0536 19.35C14.3605 19.35 16.3851 18.1841 18.2576
				15.645L22.0001 18.4049C19.3003 22.0659 15.9414 24 12.0536 24C8.17865 24 4.78861 22.0795 2 18.4388Z"
				fill={`url(#${linearGradient1})`}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.0419 6.14951L5.47145 11.8112L2.43604 8.28851L12.055 0L21.5991 8.29496L18.5488 11.8047L12.0419 6.14951Z"
				fill={`url(#${linearGradient2})`}
			/>
			<defs>
				<linearGradient
					id={linearGradient1}
					x1="2"
					y1="25.5105"
					x2="22.0001"
					y2="25.5105"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#8930FD" />
					<stop offset="1" stopColor="#49CCF9" />
				</linearGradient>
				<linearGradient
					id={linearGradient2}
					x1="2.43604"
					y1="13.9379"
					x2="21.5991"
					y2="13.9379"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FF02F0" />
					<stop offset="1" stopColor="#FFC800" />
				</linearGradient>
			</defs>
		</svg>
	);
}
